import { ChangeEvent, memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, IconButton, Box,
  Typography,
  TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import STRING_KEYS from '../../../language/keys';
import style from './style';

type Props = {
  accountName:  string,
  onConfirm: () => void;
  onClose: () => void;
  isOpen: boolean,
};

const AccountDeleteDialog = (props: Props): JSX.Element => {
  const {
    onConfirm,
    onClose, isOpen, accountName,
  } = props;
  const [accountToDeleteName, setAccountToDeleteName] = useState('');
  const { t: translate } = useTranslation();
  const checkIfAccountNameMatch = (): boolean => {
    return accountToDeleteName?.toLowerCase() === accountName?.toLowerCase();
  };

  const handleTextChange = (event: ChangeEvent<HTMLInputElement>) => {
    setAccountToDeleteName(event.target.value);
  };

  return (
    <Dialog
      open={ isOpen }
      onClose={ onClose }
    >
      <DialogTitle sx={ style.dialogTitle }>
        <Box sx={ style.titleBox }>
          <Typography variant={ style.titleVariant }>
            {translate(STRING_KEYS.ACCOUNT_DELETE_DIALOG.TITLE)}
          </Typography>
          <IconButton
            onClick={ onClose }
            sx={ style.closeIcon }
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={ style.dialogSpacing }>
          <DialogContentText>
            {translate(STRING_KEYS.ACCOUNT_DELETE_DIALOG.SUB_TITLE) }
          </DialogContentText>
          <DialogContentText>
            {translate(STRING_KEYS.ACCOUNT_DELETE_CONFIRMATION)}
          </DialogContentText>
          <TextField label={ accountName }
            fullWidth
            value={ accountToDeleteName }
            onChange={ handleTextChange }
          />
        </Box>
      </DialogContent>
      <DialogActions
        sx={ style.dialogAction }
      >
        <Button onClick={ () => {
          onClose();
        } }
        >
          {translate(STRING_KEYS.DIALOG.BTN_GO_BACK)}
        </Button>
        <Button
          sx={ style.disabledButton }
          variant="contained"
          onClick={ () => {
            onConfirm();
          } }
          color="error"
          disabled={ !checkIfAccountNameMatch() }
        >
          {translate(STRING_KEYS.ACCOUNT_DELETE_DIALOG.ACTION_BTN)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default memo(AccountDeleteDialog);
